var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCrumbDiv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.137,
    height: 8.343,
    viewBox: "0 0 7.137 8.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.842-7.61a4.329,4.329,0,0,0-.927-.324,4.329,4.329,0,0,0,.927-.324L8.109-9.941a.661.661,0,0,0,.3-.252.645.645,0,0,0,.09-.333V-12.11L1.359-8.384v.9L8.5-3.767V-5.351a.622.622,0,0,0-.09-.329.728.728,0,0,0-.3-.256Z",
    transform: "translate(8.496 -3.767) rotate(180)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrumbDiv);
export default __webpack_public_path__ + "static/media/crumb-div.07da46a3.svg";
export { ForwardRef as ReactComponent };